import { render, staticRenderFns } from "./Fuel.vue?vue&type=template&id=155db63f&scoped=true"
import script from "./Fuel.vue?vue&type=script&lang=ts"
export * from "./Fuel.vue?vue&type=script&lang=ts"
import style0 from "./Fuel.vue?vue&type=style&index=0&id=155db63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155db63f",
  null
  
)

export default component.exports